import React from 'react'

import TextToTextTransformerLayout from '../../../components/layouts/TextToTextTransformerLayout'


export default function EncoderLayout({encode, options, optionControl}) {
  const encodeFunc = React.useCallback((textInput) => {
    return encode(textInput, options)
  }, [encode, options])

  return (
    <TextToTextTransformerLayout
      transform={encodeFunc}

      inputExtraControl={
        optionControl
      }
    />
  )
}
